import { Fce } from "../fce"

export class SObject {


    constructor(json?: object, convert: boolean = true) {
        if (json) {
            if (convert)
                json = Fce.convertForClient(json)
            for (const attr in json) {
                this[attr] = json[attr]
            }
        }
    }


}